var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--ethereum",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#262C3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8726 15.4448L11.9983 15.5701L17.7566 12.1738L11.9983 2.64014L11.8726 3.06671V15.4448Z",
    fill: "#6592D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.5701V2.64014L6.23975 12.1738L11.998 15.5701Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9272 21.1538L11.9981 21.3604L17.7599 13.2637L11.9982 16.6583L11.9273 16.7445L11.9272 21.1538Z",
    fill: "#6592D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23975 13.2632L11.998 21.3599V16.6578L6.23975 13.2632Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 9.5625V15.5704L17.7562 12.1741L11.998 9.5625Z",
    fill: "#2364C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9979 9.5625L6.23975 12.1741L11.9979 15.5703V9.5625Z",
    fill: "#6D9AD5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthereum);
export default __webpack_public_path__ + "static/media/icon--ethereum.5f9df0b2d152782f7668550e9516943c.svg";
export { ForwardRef as ReactComponent };